import React from 'react';
import { interpolatePriceToTemplate, priceFormat } from '../../../utilities/helperUtility';
import { stringToBoolean } from '../../../utilities/conversionUtility';
import DepositPrice from '../DepositPrice';

export default function Price(props) {
  const {
    bodyStyles, customClassName, price, settings, totalPrice, title,
  } = props;
  const { setting } = settings;
  const value = price || totalPrice;
  const showPrice = setting && setting.hasOwnProperty('show_price') ? stringToBoolean(setting.show_price) : true;
  const fontSize = bodyStyles.fontSize || '16px';

  if (!showPrice) return '';

  return (
    <p
      className="price-container"
      style={{
        fontSize, flexWrap: 'wrap', justifyContent: 'flex-end', display: 'flex',
      }}>
      <DepositPrice {...props} />
      <span
        style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
      >
        {`${title}:`}
      </span>
      <span
        className={`ml10 ${customClassName}`}
        dangerouslySetInnerHTML={{
          __html: interpolatePriceToTemplate(priceFormat(settings), value),
        }}
      />
    </p>
  );
}
